import { Button, Input, Modal, Tabs, message } from 'antd';
import { ReactComponent as CloseIcon } from "../../../../assets/svgs/icons/close-icon.svg";
import { TransactionTableContainer } from './transaction-table.style';
import { useState } from 'react';
import { dispute_transaction } from './TransactionLambdaUtils';

const { TextArea } = Input;

interface SelectedTransactionData {
    billingGroupId: string;
    transactionId: string;
}

interface DisputeProps {
    setShow: (b: boolean) => void;
    selectedTransactionData: SelectedTransactionData;
}

const TransactionDisputeModal = ({ setShow, selectedTransactionData }: DisputeProps) => {
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [disputeMessage, setDisputeMessage] = useState<string>('');

    const handleCancel = () => {
        setShow(false)
    };

    const tabItems = [
        {
            label: (
                <span>
                    Dispute Note
                </span>
            ),
            key: '1',
            children: (
                <>
                    <div>
                    <TextArea
                            value={disputeMessage}
                            onChange={(e) => setDisputeMessage(e.target.value)}
                            placeholder="Write a dispute note"
                            autoSize={{ minRows: 6, maxRows: 6 }}
                            className='input_area'
                        />
                    </div>
                </>

            ),
        },
    ];

    const handleDisputeInfo = () => {
        setButtonLoading(true)
        dispute_transaction(selectedTransactionData?.transactionId, selectedTransactionData?.billingGroupId, disputeMessage).then((res: any) => {
            console.log(res);
            handleCancel();
        }).catch((err) => {
            message.error(err);
            console.log(err);
        }).finally(() => {
            setButtonLoading(false);
        });
    };

    return (
        <Modal
            centered
            open={true}
            onCancel={handleCancel}
            className="batch_modal create_batch_modal transaction_modal transaction_dispute_modal"
            closeIcon={<CloseIcon key="CloseIcon" color='#ffffff' onClick={handleCancel} />}
            footer={[
                <div key="footer-buttons" className="left-footer-buttons">
                    <Button onClick={handleCancel} type="primary" className="cancel_batch_button">
                        Cancel
                    </Button>
                    <Button onClick={handleDisputeInfo} loading={buttonLoading} disabled={disputeMessage === ''} type="primary" className="ok_batch_button transaction_dispute_btn">
                        Submit
                    </Button>
                </div>
            ]}
            style={{
                backgroundColor: "#36BDBE",
                width: "100%", // Adjust the width as per your need
                maxWidth: "460px", // Set maximum width if needed
            }}
        >
            <TransactionTableContainer>
                <div className='table-container'>
                    <div className="custom-tab-container">
                        <Tabs defaultActiveKey="1"
                            items={tabItems}
                            key="1"
                            className="custom-tabs">
                        </Tabs>
                    </div>
                </div>
            </TransactionTableContainer>
        </Modal>
    );
}

export default TransactionDisputeModal;
